import loadable from '@loadable/component';

export const OrgDashboardIntegrationPartnerResourcesPageLoadable = loadable(
  () => import('./OrgDashboardIntegrationPartnerResourcesPage'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardIntegrationPartnerResourcesPage,
  },
);
